// Taşeron portalı — `DocumentRow`'un eylem slotları: indir + (izin verilirse) sil. Araç ve personel
// belge listeleri AYNI bileşeni kullanır (GL5). Satır menüsü (⋮) YOK: belge listeleri çekmecede
// yaşar ve `--z-dropdown` katmanındaki bir menü çekmecenin (`--z-drawer`) perdesinin altında kalırdı.
// Silme izni çağıranın kuralıdır (araç: `canDeleteDocument`, personel: yalnız `Pending`); slot
// boşken bile genişliğini korur, İndir her satırda aynı x'te durur (`DocumentActionSlot`).
//
// ⚠️ İNDİRME §8 `documentUuid` ile yapılır; silme hedefi (kayıt/link `uuid`'i) çağıranın `onDelete`'idir.

import { Button, DocumentActionSlot, documentsApi } from '@isgportal/shared';
import { useMutation } from '@tanstack/react-query';
import { Download, Trash2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export interface DocumentActionsProps {
  doc: { documentUuid: string };
  /** Belge türünün görünen adı — düğmelerin erişilebilir adına girer. */
  typeLabel: string;
  /** Aynı türden iki belgeyi ayıran ek (dosya adı ya da geçerlilik metni) — adın sonuna `(…)` olarak eklenir. */
  nameDetail?: string;
  canDelete: boolean;
  onDelete: () => void;
}

export function DocumentActions({
  doc,
  typeLabel,
  nameDetail,
  canDelete,
  onDelete,
}: DocumentActionsProps) {
  const { t } = useTranslation();
  const name = nameDetail ? `${typeLabel} (${nameDetail})` : typeLabel;
  const download = useMutation({
    mutationFn: () => documentsApi.getDocument(doc.documentUuid), // İNDİRME: §8 documentUuid
    onSuccess: (file) => {
      window.open(file.downloadUrl, '_blank', 'noopener,noreferrer');
    },
  });
  return (
    <>
      <DocumentActionSlot>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => download.mutate()}
          loading={download.isPending}
          aria-label={`${t('permits.vehicles.docs.action.download')}: ${name}`}
          title={t('permits.vehicles.docs.action.download')}
        >
          <Download className="h-4 w-4" aria-hidden="true" />
        </Button>
      </DocumentActionSlot>
      <DocumentActionSlot>
        {canDelete ? (
          <Button
            variant="ghost"
            size="sm"
            onClick={onDelete}
            aria-label={`${t('permits.vehicles.docs.action.delete')}: ${name}`}
            title={t('permits.vehicles.docs.action.delete')}
          >
            <Trash2 className="h-4 w-4 text-danger" aria-hidden="true" />
          </Button>
        ) : null}
      </DocumentActionSlot>
    </>
  );
}
